import { AuthServicePresenceStatus } from 'Services/Auth/Auth.service.typings'

export interface UserProfile {
  id: string,
  email: string,
  displayName: string,
  firstName: string,
  lastName: string,
  initials: string,
  lang: I18nEntityLangs,
  login: string,
  mobilePhone: string,
  primaryPhone: string,
  presence: AuthServicePresenceStatus,

  // below not in store, or not used
  avatarUrl: string,
  fullName: string,
  middleName: string,
  postalAddress: AddressEntity,
  streetAddress: AddressEntity,
  timezone: string,
  username: string,
}

export interface UserAccount {
  email: string,
  firstName: string,
  lastLogin: string,
  lastName: string,
  userType: null | UserAccountUserType,
}

export enum UserAccountUserType {
  'Standard' = 'Standard',
  'Super' = 'Super',
}
